module.exports = function getResource(label, vars = []) {
    const resources = {
        guestCheckoutMessage: 'Passage en caisse sans compte',
        createAccountCheckoutMessage: 'Créer un compte',
        youCanJoinMessage: 'Vous pouvez vous inscrire à notre programme de fidélisation gratuit après votre passage en caisse.',
        joinBeautyInsiderMessage: 'Adhérez au programme de fidélisation Beauty Insider gratuitement! Ce programme ouvre la porte aux économies, échantillons et plus.',
        continueGuestButton: 'Continuer sans créer de compte',
        createAccountButton: 'Créer un compte',
        checkOutAsAGuestLink: 'Passer à la caisse en tant qu’invité',
        freeBirthdayGift: 'Cadeau\nd’anniversaire gratuit',
        seasonalSavingsEvents: 'Économies\nsaisonnières',
        sampleRewards: 'Échantillons\nde récompenses',
        bankYourBeautyPoints1: 'Accumulez des',
        bankYourBeautyPoints2: `${vars[0]} points`,
        bankYourBeautyPoints3: 'et profitez de nombreux avantages en adhérant à Beauty Insider, notre programme de fidélisation GRATUIT.'
    };

    return resources[label];
};
